import { Component, forwardRef, Renderer2, ViewChild, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BankService } from '../../../service/bank/bank.service';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectBankComponent),
  multi: true,
};

@Component({
  selector: 'app-select-bank',
  templateUrl: './select-bank.component.html',
  styleUrls: ['./select-bank.component.scss'],
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
})
export class SelectBankComponent implements ControlValueAccessor {
    @Input() bankId: number;
    @ViewChild('input') textarea;

    public banksOptions: any[];

    public onChange;
    public onTouched;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public filters: {key: string, value: string}[];

    constructor(
        private renderer: Renderer2,
        public bankService: BankService
    ) {
        this.page = 1;
        this.per_page = 100;
        this.query = undefined;
        this.filters = [];
        this.filters.push({key: 'activated-lk', value: '1'});
        this.getBanks(this.query, this.filters);
    }

    writeValue(value: any ) {
        const div = this.textarea.nativeElement;
        // this.renderer.setProperty(div, 'textContent', value);
    }

    registerOnChange(fn: any ) {
        this.onChange = fn;
    }

    registerOnTouched(fn: any ) {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean ) {
        const div = this.textarea.nativeElement;
        const action = isDisabled ? 'addClass' : 'removeClass';
        this.renderer[action](div, 'disabled');
    }

    public change($event) {
        this.onChange($event.target.value);
        this.onTouched($event.target.value);
    }

    getBanks(query?: string, filters?: any[]) {
        this.bankService.getBank(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                const banks = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }

                this.banksOptions = [];
                this.banksOptions.push({id: undefined, name: 'Choose', company: undefined});
                banks.forEach(element => {
                    if (this.bankId === element.id) {
                        this.banksOptions.push({id: element.id, name: element.name, selected: true, company: element.company});
                    } else {
                        this.banksOptions.push({id: element.id, name: element.name, selected: false, company: element.company});
                    }
                });
            },
            error => {
                this.banksOptions = [];
                this.banksOptions.push({id: '', name: 'Error'});
            }
        );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/banks/select-bank/select-bank.component.ts